import {useMemo} from 'react'
import {PlayerColor} from '@colonist/game-states'
import {useGameStore} from '../GameStoreContext'
import {PlayerValidator} from '@colonist/game-mechanic-validators'

export const usePlayerValidators = () => {
    const playerStates = useGameStore((state) => state.gameState.playerStates)
    const getUserState = useGameStore((state) => state.gameUserStates.getUserState)

    return useMemo(() => {
        const playerValidatorsMap = new Map<PlayerColor, PlayerValidator>()
        for(const [colorStr, playerState] of Object.entries(playerStates)) {
            const color = parseInt(colorStr, 10) as PlayerColor
            const userState = getUserState(color)
            const playerValidator = new PlayerValidator(playerState, userState)
            playerValidatorsMap.set(color, playerValidator)
        }

        const getPlayerValidator = (color: PlayerColor) => {
            const playerValidator = playerValidatorsMap.get(color)
            if(!playerValidator) throw new Error(`Player validator not found for color ${color}`)
            return playerValidator
        }

        return {
            playerValidators: Array.from(playerValidatorsMap.values()),
            getPlayerValidator: getPlayerValidator,
        }
    }, [playerStates, getUserState])
}
